import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { getVrrData } from "../../../../store/Api";

export default function GrReturnApproval({
  setshowPromptElement,
  showPromptElement,
  popupData,
  cancelrequest,
  setCancelrequest
}) {
  console.log("popupData....", popupData);
  const [visacount, setVisacount] = useState(
    popupData?.visa_return_requested_qty
  );
  const token = localStorage.getItem("nodeToken");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const onSubmit = async () => {

    console.log(
      "clicked.....................",
      popupData?.visa_return_requested_qty,
      visacount
    );
    if (visacount > popupData?.visa_return_requested_qty) {
      dispatch(
        setAppError({
          msg: "Visa count exceeds.",
          color: "success",
        })
      );
      return;
    }
    try{
    const reqObject = {
      visa_return_status: "GR APPROVED",
      visa_return_approval_qty: visacount,
      vrr_reference_number : popupData?.vrr_reference_number
    };

    const response = await nodeinstance.put(
      `/dashboard/vrr-visa/${popupData?.id}`,
      reqObject,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status === 200) {
      setshowPromptElement(false);
      dispatch(getVrrData(token));
      dispatch(
        setAppError({
          msg: "Updated successfully.",
          color: "success",
        })
      );
    }
  } catch(error){
    console.log("error................",error)
     dispatch(
        setAppError({
          msg: error.message,
        })
      );
  }
  };

  const onReject = async () => {
    try {
      const reqObject = {
        vrr_reference_number: popupData.vrr_reference_number,
        visa_return_requested_qty: 0,
        quantity : parseInt(popupData.visa_return_requested_qty)
      };
      const response = await nodeinstance.put(
        `/dashboard/vrr-visa/visareturnrejected/${popupData.id}`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully.",
            color: "success",
          })
        );
        dispatch(getVrrData(token));
        setshowPromptElement(false)
      }
    } catch (error) {
      console.log("error", error);
      alert("error....");
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        {cancelrequest ? (
          <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
            <div className="flex justify-between items-center w-full m-1">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setshowPromptElement(false);
                  setCancelrequest(false)
                }}
              >
                <IoMdClose />
              </h1>
            </div>
            <div>
              <h1>ARE YOU SURE YOU WANT TO REJECT THE REQUEST?</h1>
            </div>
            <div className="flex gap-3 w-full justify-center">
              <button
                className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red m-2 mt-4"
                onClick={() => {
                  onReject();
                }}
              >
                {loading ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  "Reject"
                )}
              </button>
            </div>
          </div>
        ) : (
          <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
            <div className="flex justify-between items-center w-full">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setshowPromptElement(false);
                }}
              >
                <IoMdClose />
              </h1>
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-name`} className="text-xs ">
                VISA RETURN QUANTITY
              </label>
              <input
                type="number"
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={visacount}
                onChange={(e) => {
                  setVisacount(e.target.value);
                }}
                disabled
              />
            </div>
            <div className="flex gap-3 w-full justify-center">
              <button
                className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                onClick={() => {
                  onSubmit();
                }}
              >
                {loading ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  "Approve"
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
